<template>
    <v-list dense>
        <v-list-item-group v-model="selectedItem">
            <template v-for="(item, index) in filteredMenuItems">
                <!-- Divider -->
                <v-divider v-if="item.divider" :key="`div-${index}`"></v-divider>
                
                <!-- Group with children -->
                <v-list-group 
                    v-else-if="item.children" 
                    :key="`group-${index}`" 
                    :value="item.expanded"
                    :prepend-icon="item.icon"
                >
                    <template v-slot:activator>
                        <v-list-item>
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item>
                    </template>
                    
                    <nav-item 
                        v-for="(child, childIndex) in item.children" 
                        :key="`child-${index}-${childIndex}`"
                        :title="child.title"
                        :icon="child.icon"
                        :to="child.route"
                    />
                </v-list-group>
                
                <!-- Regular nav item -->
                <nav-item 
                    v-else 
                    :key="`item-${index}`"
                    :title="item.title"
                    :icon="item.icon"
                    :to="item.route"
                />
            </template>
        </v-list-item-group>
    </v-list>
</template>

<script>
import { mapGetters } from "vuex";
import NavItem from "./NavItem.vue";

export default {
    name: "SidebarMenu",
    components: {
        NavItem
    },
    data: () => ({
        selectedItem: 0
    }),
    computed: {
        ...mapGetters({
            filteredMenuItems: "getFilteredMenuItems"
        })
    }
};
</script> 